<template>
  <div class="content-page">
    <div class="headerTab">
      <TeamLeader/>
      <a-tabs default-active-key="1" size="large">
        <a-tab-pane key="1" tab="报名费" :forceRender="true">
          <SignUpAmount ref="signUpAmount" @paySuccess="paySuccess"/>
        </a-tab-pane>
        <a-tab-pane key="2" tab="保险费" :forceRender="true">
          <InsuranceAmount ref="insuranceAmount" @paySuccess="paySuccess"/>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import InsuranceAmount from '@comm/components/join/pay/InsuranceAmount'
import SignUpAmount from './SignUpAmount'
import TeamLeader from '../staff/TeamLeader'
export default {
  components: {
    TeamLeader,
    InsuranceAmount,
    SignUpAmount
  },
  data () {
    return {}
  },
  methods: {
    // 该方法调用的来源，不为空表示是点击按钮主动调用
    paySuccess (alertMsg) {
      let signUpPayOver = this.$refs.signUpAmount.payOver()
      if (!signUpPayOver.status) {
        if (alertMsg) {
          this.$message.warning(signUpPayOver.content)
          return
        }
      }
      let insurancePayOver = this.$refs.insuranceAmount.payOver()
      if (!insurancePayOver) {
        if (alertMsg) {
          this.$message.warning('还有队员未购买保险，请先购买保险！')
          return
        }
      }
      if (signUpPayOver && insurancePayOver) {
        this.$emit('payOver')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .content-page{
    .headerTab{
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/bigBall/StepThree.vue